/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Team
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 15Mar2022 craig File created.
 \******************************************************************************/
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {
    IReviewerList,
    ISubmissionList,
    ITeam
} from "../../../../models/application/IApplication";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import "../Forms.css";
import {useFormik} from 'formik';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {getDataGet, getDataPost} from "../../../../models/data/Data";

export const Team: React.FC = (props) => {
    const {teamID} = useParams();

    const navigate = useNavigate();


    let defaultDate = new Date()
    defaultDate.setDate(defaultDate.getDate() + 3)

    const [teamName, setTeamName] = useState("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [groupDate, setGroupDate] = useState<string>("");
    const [submissions, setSubmissions] = useState<ISubmissionList[]>([]);
    const [reviewers, setReviewers] = useState<IReviewerList[]>([]);
    const [selectedReviewers, setSelectedReviewers] = useState<string[]>([]);
    const [selectedSubmissions, setSelectedSubmissions] = useState<string[]>([]);
    const [jumpStartText, setJumpStartText] = useState<string>("");

    const [team, setTeam] = useState<ITeam>({
        TeamID: -1,
        TeamName: "",
        StartDate: new Date(),
        EndDate: new Date(),
        GroupDate: new Date(),
        JumpStart: "",
    });


   /*
        const today = new Date();
        const schema = Yup.object().shape({
        teamname: Yup.string().required(),
        reviewers: Yup.array().of(Yup.string()),
        submissions: Yup.array().of(Yup.string()).min(1).max(5).required(),
        startdate: Yup.date().min(today, "Can not pick a day in the past").required(),
        enddate: Yup.date().required(),
        groupdate: Yup.date().required(),
        jumpstart: Yup.string().required(),
    });*/

    useEffect(() => {
        if (teamID !== undefined) {
            const teamURL = process.env.REACT_APP_API_URL + "/api/admin/team/" + teamID;
            getDataGet(teamURL).then(response => {
                setTeam(response);
                setTeamName(response.TeamName)
                setStartDate(new Date(response.StartDate).toISOString().substring(0, 10));
                setEndDate(new Date(response.EndDate).toISOString().substring(0, 10));
                setGroupDate(new Date(response.GroupDate).toISOString().substring(0,10));

                setJumpStartText(response.JumpStart);

                let tmpSubmissions = new Array<string>();
                if (response.TeamSubmissionLinkage != null && response.TeamSubmissionLinkage.length > 0) {
                    response.TeamSubmissionLinkage.map(linkage => {
                        tmpSubmissions.push(linkage.SubmissionID);
                        return "";
                    })
                }
                setSelectedSubmissions(tmpSubmissions)

                let tmpReviewers = new Array<string>();
                if (response.TeamUserLinkage != null && response.TeamUserLinkage.length > 0) {
                    response.TeamUserLinkage.map(linkage => tmpReviewers.push(linkage.UserID));
                }
                setSelectedReviewers(tmpReviewers);
            })

        }
        //get the free submissions
        const appURL = process.env.REACT_APP_API_URL + "/api/admin/freesubmissions";
        getDataGet(appURL).then(response => {
            setSubmissions(response);
        })
        //get the reviewers
        const reviewerURL = process.env.REACT_APP_API_URL + "/api/admin/reviewerlist";
        getDataGet(reviewerURL).then(response => {
            setReviewers(response);
        })

    }, [teamID])

    function getTitle() {
        if (teamID !== undefined) {
            return "Edit Team";
        } else {
            return "Add New Team";
        }
    }

    const buildReviewersList = () => {
        /*        let allReviewers = reviewers.map(item => ({...item}));
                if (team.TeamUserLinkage != null && team.TeamUserLinkage.length > 0) {
                    team.TeamUserLinkage.map(linkage => {
                        let tmpItem = {} as IReviewerList;
                        tmpItem.UserID = linkage.UserID;
                        tmpItem.FirstName = linkage.GSUser?.FirstName;
                        tmpItem.LastName = linkage.GSUser?.LastName;
                        tmpItem.EmailAddress = linkage.GSUser?.EmailAddress;
                        if (allReviewers.find())
                        allReviewers.push(tmpItem);
                    })
                }*/

        let optionTemplate = reviewers.map(v => (
            <option key={v.UserID}
                    value={v.UserID}>{v.FirstName + " " + v.LastName + "(" + v.EmailAddress + ")"} </option>
        ));
        return optionTemplate;


    }
    const buildSubmissionsList = () => {
        let allSubmissions = submissions.map(item => ({...item}));
        if (team.TeamSubmissionLinkage != null && team.TeamSubmissionLinkage.length > 0) {
            team.TeamSubmissionLinkage.map(linkage => {
                let tmpItem = {} as ISubmissionList;
                tmpItem.SubmissionID = linkage.SubmissionID;
                tmpItem.Organization = linkage.Submission.Organization;

                allSubmissions.push(tmpItem);
                return "";
            })
        }
        allSubmissions.sort(function (a, b) {
            const org1 = a.Organization.toLowerCase();
            const org2 = b.Organization.toLowerCase();
            if (org1 < org2) {
                return -1;
            }
            if (org1 > org2) {
                return 1;
            }
            return 0;
        })
        let optionTemplate = allSubmissions.map(v => (
            <option key={v.SubmissionID} value={v.SubmissionID}>{v.Organization}</option>
        ));
        return optionTemplate;
    }

    /*    const handleSubmissionSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
            const application = submissions?.find(e => e.SubmissionID.toString() === event.target.value)?.SubmissionTitle;
            if (application !== undefined) {
                setSelectedSubmission(event.target.value);
                //setSelectedRoleName(role);
            }

        }*/


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            teamname: teamName ?? '',
            reviewers: selectedReviewers ?? '',
            submissions: selectedSubmissions ?? '',
            startdate: startDate ?? '',
            enddate: endDate ?? '',
            groupdate: groupDate ?? '',
            jumpstart: jumpStartText ?? '',
        },
        onSubmit: values => {
            const data = `${encodeURIComponent("teamname")}=${encodeURIComponent(values.teamname)}
            &${encodeURIComponent("reviewers")}=${encodeURIComponent(values.reviewers.join(":"))}
                    &${encodeURIComponent("submissions")}=${encodeURIComponent(values.submissions.join(":"))}
                    &${encodeURIComponent("startdate")}=${encodeURIComponent(values.startdate)}
                    &${encodeURIComponent("enddate")}=${encodeURIComponent(values.enddate)}
                    &${encodeURIComponent("groupdate")}=${encodeURIComponent(values.groupdate)}
                    &${encodeURIComponent("jumpstart")}=${encodeURIComponent(values.jumpstart)}`;
            let teamUpdateURL = process.env.REACT_APP_API_URL + "/api/admin/";
            if (teamID !== undefined) {
                teamUpdateURL += "updateteam/" + teamID;
            } else {
                teamUpdateURL += "newteam";
            }
            getDataPost(teamUpdateURL, data).then(response => {
                navigate("/admin/teams");
            })
        },
        validateOnChange: false,
        validateOnBlur: false,
    });

    const inputHandler = (event, editor) => {
        formik.setFieldValue("jumpstart", editor.getData());
    };

    const buildFormButtons = () => {
        let subButton = "Create New Team";
        if (teamID !== undefined) {
            subButton = "Save Team"
        }
        return (
            <Row>
                <Col>
                    <Button variant="primary" className="btn-submit" type="submit">
                        {subButton}
                    </Button>
                </Col>
            </Row>
        )
    }

    const buildForm = () => {
        return (
            <Form className={"form-layout"} onSubmit={formik.handleSubmit} noValidate={true}>
                <Row className="mb-3">
                    <Form.Group as={Col} className="col-left" controlId="formBasicName">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control required
                                      name={"teamname"}
                                      className="text-mid-width"
                                      type="text"
                                      placeholder="Enter team name"
                                      value={formik.values.teamname}
                            //isValid={formik.touched.teamname && !formik.errors.teamname}
                                      onChange={formik.handleChange}/>
                        <Form.Text className="text-muted">Enter team name.</Form.Text>
                        <Form.Control.Feedback type="invalid">
                            Please provide a team name
                        </Form.Control.Feedback>
                        {/*                                <ErrorMessage name={"teamname"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}
                    </Form.Group>
                </Row>
                <Row className="mb-3">
                    <Form.Group as={Col} className={"col-left"} controlId={"formApplication"}>
                        <Form.Label>Select Reviewers</Form.Label>
                        <Form.Control as={"select"}
                                      name={"reviewers"}
                                      multiple
                                      value={formik.values.reviewers}
                                      className="text-full-width"
                                      onChange={formik.handleChange}>
                            {buildReviewersList()}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Please select at least one Submission
                        </Form.Control.Feedback>
                        {/*                                <ErrorMessage name={"submissions"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}

                    </Form.Group>
                    <Form.Group as={Col} className={"col-left"} controlId={"formApplication"}>
                        <Form.Label>Select Submissions *</Form.Label>
                        <Form.Control as={"select"}
                                      name={"submissions"}
                                      multiple
                                      value={formik.values.submissions}
                                      className="text-full-width"
                                      onChange={formik.handleChange}>
                            {buildSubmissionsList()}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Please select at least one Submission
                        </Form.Control.Feedback>
                        {/*                                <ErrorMessage name={"submissions"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}

                    </Form.Group>
                </Row>
                <Row className={"mb-3"}>
                    <Col>
                        <Form.Group as={Col} className={"col-left"}>
                            <Form.Label>Start Date *</Form.Label>
                            <Form.Control
                                name={"startdate"}
                                type={"date"}
                                defaultValue={formik.values.startdate}
                                onChange={formik.handleChange}/>
                            <Form.Control.Feedback type="invalid">
                                Please select a start date
                            </Form.Control.Feedback>
                            {/*                                    <ErrorMessage name={"startdate"}
                                                  render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} className={"col-left"}>
                            <Form.Label>End Date *</Form.Label>
                            <Form.Control
                                name={"enddate"}
                                type={"date"}
                                defaultValue={formik.values.enddate}
                                onChange={formik.handleChange}/>
                            <Form.Control.Feedback type="invalid">
                                Please select a end date
                            </Form.Control.Feedback>
                            {/*                                    <ErrorMessage name={"enddate"}
                                                  render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group as={Col} className={"col-left"}>
                            <Form.Label>Group Session Date *</Form.Label>
                            <Form.Control
                                name={"groupdate"}
                                type={"date"}
                                defaultValue={formik.values.groupdate}
                                onChange={formik.handleChange}/>
                            <Form.Control.Feedback type="invalid">
                                Please select a date for group meeting
                            </Form.Control.Feedback>
                            {/*                                    <ErrorMessage name={"startdate"}
                                                  render={msg => <div className={"form-error-msg"}>{msg}</div>}/>*/}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Form.Group as={Col} className={"col-left"}>
                        <Form.Label>Jump Start *</Form.Label>
                        <CKEditor editor={ClassicEditor}
                                  onReady={(editor) => {
                                      editor.editing.view.change((writer) => {
                                          writer.setStyle(
                                              "height",
                                              "400px",
                                              editor.editing.view.document.getRoot()
                                          );
                                      })
                                  }}
                                  data={jumpStartText}
                                  onChange={inputHandler}
                        />
                    </Form.Group>
                </Row>
                {buildFormButtons()}
            </Form>
        )
    }

    /*function teamData() {
        let teamUpdateURL = "http://localhost:10001/admin/";
        if (teamID !== undefined) {
            teamUpdateURL += "updateteam/" + teamID;
        } else {
            teamUpdateURL += "newteam";
        }

        return axios.post(teamUpdateURL,
            `${encodeURIComponent("teamname")}=${encodeURIComponent(teamName)}
                &${encodeURIComponent("application")}=${encodeURIComponent(selectedSubmission)}
                &${encodeURIComponent("startdate")}=${encodeURIComponent(startDate)}
                &${encodeURIComponent("enddate")}=${encodeURIComponent(endDate)}
                &${encodeURIComponent("jumpstart")}=${encodeURIComponent(jumpStartText)}`,
            {
                withCredentials: true,
                "headers": {
                    "Content-Type": "submission/x-www-form-urlencoded"
                }
            })
            .then(response => response.data)
            .catch(err => console.error(err))
    }*/

    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1 className="page-title">{getTitle()}</h1>
                </Col>
            </Row>
            {buildForm()}
            {/*
            <Form className={"form-layout"} validated={!validated} onSubmit={handleSubmit} noValidate={true}>
                <Row className="mb-3">
                    <Form.Group as={Col} className="col-left" controlId="formBasicName">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control required className="text-mid-width" type="text" placeholder="Enter name"
                                      defaultValue={team.TeamName}
                                      onChange={(event) => setTeamName(event.target.value)}/>
                        <Form.Text className="text-muted">Enter users name.</Form.Text>
                        <Form.Control.Feedback type="invalid">
                            Please provide a full name
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} className={"col-left"} controlId={"formApplication"}>
                        <Form.Label>Select Application *</Form.Label>
                        <Form.Control as={"select"} className="text-mid-width"
                                      value={selectedApplication}
                                      onChange={handleApplicationSelect}>
                            {buildApplicationList()}
                        </Form.Control>
                    </Form.Group>
                </Row>
                <Row className={"mb-3"}>
                    <Col>
                        <Form.Group as={Col} className={"col-left"}>
                            <Form.Label>Start Date *</Form.Label>
                            <Form.Control type={"date"} defaultValue={startDate}
                                          onChange={(event) => setStartDate(event.target.value)}
                                          required/>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} className={"col-left"}>
                            <Form.Label>End Date *</Form.Label>
                            <Form.Control type={"date"} defaultValue={endDate}
                                          onChange={(event) => setEndDate(event.target.value)}
                                          required/>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Form.Group as={Col} className={"col-left"}>
                        <Form.Label>Jump Start *</Form.Label>
                        <CKEditor
                            initData={jumpStartText}
                        />
                        <CKEditor editor={ClassicEditor}
                                  onReady={(editor) => {
                                      editor.editing.view.change((writer) => {
                                          writer.setStyle(
                                              "height",
                                              "400px",
                                              editor.editing.view.document.getRoot()
                                          );
                                      })
                                  }}
                                  data={jumpStartText}
                                  onChange={(event, editor) => {
                                      setJumpStartText(editor.getData());

                                      const data = editor.getData();
                                      console.log({event, editor, data});

                                  }}
                        />
                    </Form.Group>
                </Row>
                <Row>
                    <Col>
                        <Button variant="primary" className="btn-submit" type="submit">
                            Save Team Information
                        </Button>
                    </Col>
                </Row>
                {TeamUsersTable(team.TeamUserLinkage, true, true)}
                <Row>
                    <Col>
                        <Button variant="primary" className="btn-submit" type="button" href={"/admin/team"}>
                            Add Team Member
                        </Button>
                    </Col>
                </Row>

            </Form>
*/}

        </Container>
    )
}